import { render, staticRenderFns } from "./StudentField.vue?vue&type=template&id=0e158b54&"
import script from "./StudentField.vue?vue&type=script&lang=js&"
export * from "./StudentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports